import { ICON__lock } from '@/assets/icons_fa';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_UI_FIELD__header_icon_lock({ field }: PROPS) {
  let [need_render_icon_lock, text] = [false, ''];

  if (field.meta.ui__is_readonly) [need_render_icon_lock, text] = [true, 'Field is read only'];
  if (field.meta.kind__is_output) [need_render_icon_lock, text] = [true, 'Field is output'];
  if (field.meta.data__is_linked) [need_render_icon_lock, text] = [true, 'Field is linked'];

  if (!need_render_icon_lock) return null;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={text}>
      <span className="inline-flex flex-shrink-0">
        <ICON__lock className="size-3 !text-component-bar-foreground flex-shrink-0" />
      </span>
    </UI_PRIMITIVE__tooltip>
  );
}
